// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconXsol } from "../../../icons/full/build/icon-xsol.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const XsolIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconXsol.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  XsolIcon.displayName = 'XsolIcon';
}

export default XsolIcon;